'use strict';

exports.distance = require('./distances');
exports.similarity = require('./similarities');


// WEBPACK FOOTER //
// ./node_modules/ml-distance/src/index.js